import { useQuery } from '@tanstack/react-query';

import type { FiatCurrencyCode } from '@/constants/fiatCurrency';
import { FX_RATE_REFRESH_INTERVAL } from '@/constants/fiatCurrency';

import { useCurrencyStore, setFxRatesSelector } from '@/store/currency';

import { fetchWithJwt, getFullURL, handleResponse } from '@/utils/fetcher';
import { routes } from '@/utils/routes';

export const fxRatesQueryKey = () => ['fx-rates'] as const;

/**
 * Fetches FX rates from the API and writes them into the currency store.
 * Should be mounted once near the app root.
 */
export const useFxRates = () => {
  const setFxRates = useCurrencyStore(setFxRatesSelector);

  return useQuery({
    queryKey: fxRatesQueryKey(),
    queryFn: async () => {
      const response = await fetchWithJwt(getFullURL(routes.api.FX_RATES));
      const data = await handleResponse<Partial<Record<FiatCurrencyCode, number>>>(response);
      setFxRates(data);
      return data;
    },
    refetchInterval: FX_RATE_REFRESH_INTERVAL,
  });
};
